import * as React from 'react';
import {
  HeaderContainer,
  HeaderContentContainer,
} from '>shared/components/layouts/responsive/responsiveAppComponents';
import {HeaderLogo} from '>shared/components/landmarks/header/header.styles';
import {wonscoreHeaderLogoMobile} from '>shared/components/icon/icons';

export const Header: React.FC = () => {
  return (
    <HeaderContainer>
      <HeaderContentContainer>
        <HeaderLogo src={wonscoreHeaderLogoMobile} uniquifyIDs />
      </HeaderContentContainer>
    </HeaderContainer>
  );
};
